import { Tooltip } from '@mui/material'
import { TriangleAlert } from 'lucide-react'

const PointsCard = ({ language = 'castellano', userPoints = null }) => {
    const {
        earnedPoints,
        spentPoints,
        availablePoints,
        pointsExpiringIn6Months,
        pointsExpiringIn2Months,
        expiredPoints,
    } = userPoints || {}

    return (
        <div className="max-w-6xl mx-auto pb-4 ">
            {/* Header with warning */}

            {/* Main content in horizontal layout */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                {/* Warning Card - takes 1 column */}
                <div className="border-2 border-grey-500 bg-white-50 rounded-lg shadow-sm">
                    <div className="p-3">
                        <div className="flex items-start space-x-3">
                            <Tooltip
                                title={
                                    <div className="bg-gray-50 rounded-lg p-4">
                                        <h4 className="font-semibold text-gray-800 mb-1 text-sm">
                                            {language === 'castellano'
                                                ? 'información importante'
                                                : 'informació important'}
                                        </h4>
                                        <ul className="text-xs text-gray-600 space-y-0.5">
                                            <li>
                                                •{' '}
                                                {language === 'castellano'
                                                    ? 'Los puntos caducan en 6 meses.'
                                                    : 'Els punts caduquen al cap de 6 mesos.'}
                                            </li>
                                            <li>
                                                •{' '}
                                                {language === 'castellano'
                                                    ? 'Revisa regularmente los puntos que están próximos a caducar'
                                                    : 'Revisa regularment els punts que están pròxims a caducar'}
                                            </li>
                                            <li>
                                                •{' '}
                                                {language === 'castellano'
                                                    ? 'Hay un límite máximo de 200 puntos disponibles por usuario.'
                                                    : 'Hi ha un límit màxim de 200 punts disponibles per usuari.'}
                                            </li>
                                        </ul>
                                    </div>
                                }
                                placement="top"
                                arrow
                            >
                                <TriangleAlert className="h-5 w-5 mt-1 flex-shrink-0 text-red-500" />
                            </Tooltip>
                            <div className="space-y-1">
                                <h2 className="text-base font-semibold text-gray-800">
                                    Nº pts disponibles:{' '}
                                    <span className="text-lg font-bold text-black-600">{availablePoints}</span>
                                </h2>
                                <div className="text-gray-700 text-sm">
                                    <p className="font-medium">
                                        pts disponibles{' '}
                                        {language === 'castellano' ? 'caducan en 2 meses' : 'caduquen en 2 mesos'}:{' '}
                                        <span className="text-lg font-bold text-black-600">
                                            {pointsExpiringIn2Months}
                                        </span>
                                    </p>
                                    <p className="font-medium">
                                        pts disponibles{' '}
                                        {language === 'castellano' ? 'caducan en 3-6 meses' : 'caduquen en 3-6 mesos'}:{' '}
                                        <span className="text-lg font-bold text-black-600">
                                            {pointsExpiringIn6Months}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Points Summary Cards - takes 2 columns */}
                <div className="lg:col-span-2">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                        <div className="bg-white shadow-sm rounded-lg border">
                            <div className="p-3">
                                <h3 className="text-sm font-semibold text-gray-700 mb-1">
                                    Nº pts {language === 'castellano' ? 'obtenidos' : 'obtinguts'}
                                </h3>
                                <div className="text-xl font-bold text-green-600">{earnedPoints}</div>
                            </div>
                        </div>

                        <div className="bg-white shadow-sm rounded-lg border">
                            <div className="p-3">
                                <h3 className="text-sm font-semibold text-gray-700 mb-1">
                                    Nº pts {language === 'castellano' ? 'gastados' : 'consumits'}
                                </h3>
                                <div className="text-xl font-bold text-blue-600">{spentPoints}</div>
                            </div>
                        </div>

                        <div className="bg-white shadow-sm rounded-lg border">
                            <div className="p-3">
                                <h3 className="text-sm font-semibold text-gray-700 mb-1">
                                    Nº pts {language === 'castellano' ? 'caducados' : 'caducats'}
                                </h3>
                                <div className="text-xl font-bold text-red-600">{expiredPoints}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PointsCard
